import {
    createApp
} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import config from "./methods/config.js";
import methods from "./methods/methods.js";

import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";

import "./assets/css/global.css";
import '@/assets/css/font.css'
import TableList from "./components/tableList.vue";
import SearchForm from "./components/searchForm.vue";
import SubmitForm from "./components/submitForm.vue";
import ImageShow from "@/components/ImageShow.vue";
import upload from '@/components/upload.vue'
import usePermission from "./methods/permissionUtils.js";
const {
    hasPermission
} = usePermission();

const app = createApp(App);
app.component("TableList", TableList);
app.component("SearchForm", SearchForm);
app.component("SubmitForm", SubmitForm);
app.component('Upload', upload);
app.component("ImageShow", ImageShow);

app.config.globalProperties.$config = config;
app.config.globalProperties.$methods = methods;
app.config.globalProperties.isPerms = hasPermission;
app.use(router);
app.use(store);
app.use(Antd).mount("#app");